import { render, staticRenderFns } from "./Locataire.vue?vue&type=template&id=5fa89bcc&scoped=true&"
import script from "./Locataire.vue?vue&type=script&lang=js&"
export * from "./Locataire.vue?vue&type=script&lang=js&"
import style0 from "./Locataire.vue?vue&type=style&index=0&id=5fa89bcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa89bcc",
  null
  
)

export default component.exports